import toggleAttachment from './common/toggle-attachment'

function toggleThisAttachment() {
  toggleAttachment($(this))
}

export default () => {
  $(document).on(
    'updated',
    '[data-behaviour="export-check-account-or-text"]',
    toggleThisAttachment
  )

  return () => {
    $(document).off(
      'updated',
      '[data-behaviour="export-check-account-or-text"]',
      toggleThisAttachment
    )
  }
}
